import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./NobleVillage.module.css";
import MathBalloonPop from "../games/MathBalloon";
import GameWrapper from "../GameWrapper";
import GameTemplate from "../games/GameTemplate";

const NobleVillage = () => {
  const navigate = useNavigate();

  const handleButtonClick = (path) => {
    navigate(path);
  };

  return (
    <GameWrapper backgroundImage="/NobleVillage.webp">
      <button
        onClick={() => handleButtonClick("/home")}
        className={`${styles.homeButton} ${styles.button}`}
      >
        Home
      </button>

      <button
        onClick={() => handleButtonClick("/map")}
        className={`${styles.mapButton} ${styles.button}`}
      >
        Map
      </button>

      <MathBalloonPop />
    </GameWrapper>
  );
};

export default NobleVillage;